export const I18n = {
    'en': {
        modal: {
            addOrEditFolder: 'Add / Edit folder',
            addOrEditMedia: 'Add / Edit media',
            shared: 'Shared',
            downloadCsv: 'Download CSV'
        },
        player: 'Player',
        all: 'All',
        company: 'Company',
        mediaOwner: 'Media owner',
        store: 'Store',
        stores: 'Stores',
        filter: "Filtering",
        resetFilters: 'Reset filters',
        searchPlaceholder: 'Search...',
        searchMedia: 'Search media',
        searchStore: 'Search store',
        dateFrom: 'From Date',
        dateTo: 'To Date',
        asc: 'Ascending',
        desc: 'Descending',
        folder: 'Folder',
        media: 'Media',
        activeSalesPoints: 'Active sales points',
        mediaPlaybackCount: 'Media playback count',
        playbackCountByStores: 'Playback count by stores',
        totalDuration: 'Total duration',
        folders: 'Folders',
        addFolder: 'Add folder',
        addMedia: 'Add media',
        mediaAlreadyExists: 'A media with the same name already exists in the selected folder',
        name: 'Name',
        choose: "Choose",
        thisFieldCanNotBeEmpty: "This field cannot be empty",
        durationFormat: '%d h %d min %d sec',
        reset: 'Reset',
        contactUsToAccessThis: 'Contact info@hankuper.com to access this functionality',
    },
    'ru': {
        modal: {
            addOrEditFolder: 'Добавить / Изменить папку',
            addOrEditMedia: 'Добавить / Изменить медиа',
            shared: 'Общая',
            downloadCsv: 'Выгрузить в CSV'
        },
        player: 'Плеер',
        all: 'Все',
        company: 'Компания',
        mediaOwner: 'Владелец медиа',
        store: 'Магазин',
        stores: 'Магазины',
        filter: "Применить фильтры",
        resetFilters: 'Сбросить фильтры',
        searchPlaceholder: 'Поиск...',
        searchMedia: 'Поиск медиа',
        searchStore: 'Поиск магазина',
        dateFrom: 'C даты',
        dateTo: 'По дату',
        asc: 'По возрастанию',
        desc: 'По убыванию',
        folder: 'Папка',
        media: 'Медиа',
        activeSalesPoints: 'Активные торговые точки',
        mediaPlaybackCount: 'Количество воспроизведений медиа',
        playbackCountByStores: 'Количество воспроизведений по магазинам',
        totalDuration: 'Общая продолжительность',
        folders: 'Папки',
        addFolder: 'Добавить папку',
        addMedia: 'Добавить медиа',
        folderAlreadyExists: 'Папка с таким названием уже существует',
        mediaAlreadyExists: 'Медиа с таким названием уже есть в выбранной папке',
        name: 'Имя',
        choose: "Выбрать",
        durationFormat: '%d ч %d мин %d сек',
        reset: 'Сбросить',
        contactUsToAccessThis: 'Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com',
    },
};


// WEBPACK FOOTER //
// ./src/I18n/components/player/index.js